import ImageSizeTypes from 'ContentUtils/constants/ImageSizeTypes';
// Selectors
export const getImageDataForCmv1OrCmv2 = data => {
  if (data.type === 'module' || data.img) {
    return data.img || {};
  }
  return data;
};
const getOrCreateImageElement = (domElement, {
  src
}) => {
  let imgElement = domElement.querySelector('img');
  if (!imgElement && src) {
    // I'm afraid of removing this, but i'm unclear how this is doing anything, other than creating
    // a img dom reference  that is never actually referenced.
    imgElement = document.createElement('img');
    imgElement.classList.add('hs-image-widget');
  }
  return imgElement;
};
export const updateImageDom = (imgElement, data) => {
  if (!imgElement) {
    return;
  }
  const {
    src,
    alt,
    size_type,
    width,
    height,
    max_width,
    max_height
  } = data;
  if (src) {
    imgElement.setAttribute('src', src);
  }
  if (alt) {
    imgElement.setAttribute('alt', alt);
  } else {
    // Reference: https://git.hubteam.com/HubSpot/ContentEditorUI/issues/15707
    imgElement.setAttribute('alt', '');
  }

  // This logic will need to be kept up to date with ImageWidgetTag.java within the cos-renderer
  if (!size_type) {
    if (width) {
      imgElement.setAttribute('width', `${width}px`);
      imgElement.style.width = `${width}px`;
    } else {
      imgElement.removeAttribute('width');
      imgElement.style.removeProperty('width');
    }
  } else {
    switch (size_type) {
      case ImageSizeTypes.AUTO:
        {
          imgElement.removeAttribute('width');
          imgElement.removeAttribute('height');
          imgElement.style.removeProperty('width');
          imgElement.style.height = 'auto';
          imgElement.style.maxWidth = '100%';
          imgElement.style.removeProperty('max-height');
          break;
        }
      case ImageSizeTypes.AUTO_CUSTOM_MAX:
        {
          imgElement.setAttribute('width', '100%');
          imgElement.setAttribute('height', 'auto');
          imgElement.style.removeProperty('width');
          imgElement.style.removeProperty('height');
          if (max_width) {
            imgElement.style.maxWidth = `${max_width}px`;
          } else {
            imgElement.style.removeProperty('max-width');
          }
          if (max_height) {
            imgElement.style.maxHeight = `${max_height}px`;
          } else {
            imgElement.style.removeProperty('max-height');
          }
          break;
        }
      default:
        {
          if (width) {
            imgElement.setAttribute('width', `${width}px`);
          } else {
            imgElement.removeAttribute('width');
          }
          if (height) {
            imgElement.setAttribute('height', `${height}px`);
          } else {
            imgElement.removeAttribute('height');
          }
          imgElement.style.removeProperty('width');
          imgElement.style.removeProperty('height');
          imgElement.style.removeProperty('max-width');
          imgElement.style.removeProperty('max-height');
          break;
        }
    }
  }
};

// Updates
export const updateImageModuleDom = (domElement, data) => {
  const imageData = getImageDataForCmv1OrCmv2(data);
  const imgElement = getOrCreateImageElement(domElement, {
    src: imageData.src
  });
  updateImageDom(imgElement, imageData);
};
export function computeUpdatedImageSizePreservingAspectRatio(originalRect, corner, dragSource, clientX, clientY) {
  const aspectRatio = originalRect.width / originalRect.height;
  const xDelta = clientX - dragSource.x;
  const yDelta = clientY - dragSource.y;
  const xAbsDelta = Math.abs(xDelta);
  const yAbsDelta = Math.abs(yDelta);
  let newWidth;
  let newHeight;
  switch (corner) {
    case 'topleft':
      {
        if (xAbsDelta > yAbsDelta) {
          newWidth = originalRect.width - xDelta;
          newHeight = newWidth / aspectRatio;
        } else {
          newHeight = originalRect.height - yDelta;
          newWidth = newHeight * aspectRatio;
        }
        newHeight = Math.round(newHeight);
        newWidth = Math.round(newWidth);
        return {
          newWidth,
          newHeight
        };
      }
    case 'topright':
      {
        if (xAbsDelta > yAbsDelta) {
          newWidth = originalRect.width + xDelta;
          newHeight = newWidth / aspectRatio;
        } else {
          newHeight = originalRect.height - yDelta;
          newWidth = newHeight * aspectRatio;
        }
        newHeight = Math.round(newHeight);
        newWidth = Math.round(newWidth);
        return {
          newWidth,
          newHeight
        };
      }
    case 'bottomleft':
      {
        if (xAbsDelta > yAbsDelta) {
          newWidth = originalRect.width - xDelta;
          newHeight = newWidth / aspectRatio;
        } else {
          newHeight = originalRect.height + yDelta;
          newWidth = newHeight * aspectRatio;
        }
        newHeight = Math.round(newHeight);
        newWidth = Math.round(newWidth);
        return {
          newWidth,
          newHeight
        };
      }
    case 'bottomright':
      {
        if (xAbsDelta > yAbsDelta) {
          newWidth = originalRect.width + xDelta;
          newHeight = newWidth / aspectRatio;
        } else {
          newHeight = originalRect.height + yDelta;
          newWidth = newHeight * aspectRatio;
        }
        newHeight = Math.round(newHeight);
        newWidth = Math.round(newWidth);
        return {
          newWidth,
          newHeight
        };
      }
    default:
      return null;
  }
}